<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{ header }}</h5>
    </div>
    <b-form @submit.prevent="onSubmit()">
      <legend>Vehicle Group Detail</legend>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="input_name">Name</label>
          <input
            name="Name"
            id="input_name"
            type="text"
            class="form-control"
            v-validate="'required'"
            v-model.trim="form.name"
            :class="{'is-invalid': errors.has('name')}"
            placeholder="Enter Name">
          <b-form-feedback>{{ errors.first('name') }}</b-form-feedback>
        </div>
        <div class="form-group col-md-6">
          <label for="description">Description</label>
           <input
            name="Description"
            id="input_description"
            type="text"
            class="form-control"
            v-model.trim="form.description"
            :class="{'is-invalid': errors.has('description')}"
            placeholder="Enter Description">
          <b-form-feedback>{{ errors.first('description') }}</b-form-feedback>
        </div>
      </div>
      <legend v-if="!isEdit">Company</legend>
      <div
        class="form-row"
        v-if="!isEdit">
        <div class="form-group col-md-6">
          <label>Company</label>
            <company-multi-select
              :multiple="false"
              type="TRANSPORTER"
              :init-selection-id="vehicleCompanyId"
              @on-selected="onCompanySelected"
              required
            />
        </div>
      </div>
      <hr>
      <b-button
        type="submit"
        id="createBtn"
        :disabled="disabled"
        variant="primary">
        <span v-if="beforeClick">Save changes</span>
        <span v-else> Loading..</span>
        <i v-if="loadingSpinner" class="fa fa-spinner fa-spin"></i>
      </b-button>
      <b-button
        @click="onCancel()"
        type="reset"
        variant="outline-secondary"
        class="pull-right">Cancel</b-button>
    </b-form>
  </b-card>
</template>
<script>
/* eslint-disable */
import Multiselect from 'vue-multiselect';
import CompanyMultiSelect from '@/components/CompanyMultiSelect.vue';
import { isEmpty, isObject, get } from 'lodash';

export default {
  components: {
    Multiselect,
    CompanyMultiSelect,
  },
  name: 'vehicle_detail',
  data() {
    return {
      form: {
        id: null,
        name: '',
        company: null,
        description: '',
      },
      loadingSpinner: false,
      beforeClick: true,
      disabled: false,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'vehicle_group', name: 'Vehicles Group' },
      { to: 'create', name: 'Create' },
    ]);
    const { vehicleGroupId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'vehicle_group', name: 'Vehicle Group' },
      { to: vehicleGroupId, name: 'Detail' },
      { to: 'edit', name: 'Edit' },
    ];

    if (!this.isEdit) {
      breadcrumb.splice(2, 3);
      breadcrumb.push({ to: 'create', name: 'Create' });
    } else {
      this.$store.commit('vehicle_group/SET_DETAIL_ID', vehicleGroupId);
      this.$store.dispatch('vehicle_group/LOAD_DETAIL_DATA');
    }
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    detailedInfo() {
      const detailInfo = this.isEdit ? this.$store.getters['vehicle_group/get_detail_data'] : {};
      return detailInfo;
    },
    vehicleCompanyId() {
      if (this.isEdit) {
        return get(this.detailedInfo, 'company.id', '');
      }
      return this.userData.company_id.toString();
    },
    displayName() {
      return this.detailedInfo.name;
    },
    header() {
      const header = this.isEdit
        ? `Edit Vehicle: ${this.displayName}`
        : 'Create New Vehicle Group';
      return header;
    },
    userData() {
      return this.$store.getters.userData;
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    isEdit() {
      return !isEmpty(this.$route.params.vehicleGroupId);
    },
    isAddFromSelectedCompany() {
      return !isEmpty(this.$route.params.companyId);
    },
  },
  watch: {
    detailedInfo(data) {
      const { form } = this;
      form.id = data.id;
      form.name = data.name;
      form.description = data.description;
    },
  },
  methods: {
    onCompanySelected(company) {
      if (isObject(company)) {
        this.form.company = company;
      }
    },
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          this.loadingSpinner = true;
          this.beforeClick = false;
          this.disabled = true;
          let { vehicleGroupId } = this.$route.params;
          const { companyId } = this.$route.params;
          const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';
          this.$store.dispatch(`vehicle_group/${action}`, this.form).then((vehicle_group) => {
            if (companyId) {
              this.$router.push(`/admin/companies/${companyId}/vehicles`);
            } else {
              vehicleGroupId = this.isEdit ? vehicleGroupId : vehicle_group.id;
              this.$router.push(`/vehicle_group/${vehicleGroupId}`);
            }
          });
        } else {
          this.loadingSpinner = false;
          this.beforeClick = true;
          this.disabled = false;
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      const { vehicleGroupId } = this.$route.params;
      if (this.isEdit) {
        this.$router.push(`/vehicle_group/${vehicleGroupId}`);
      }  else {
        this.$router.push('/vehicle_group');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/vehicle_group/CreateEdit.vue